import smoothscroll from 'smoothscroll-polyfill'

// Smooth scroll polyfill for https://caniuse.com/#feat=mdn-api_scrolltooptions
smoothscroll.polyfill()
